import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddApplicantService {
  public applicantAdded$ = new Subject<void>();
  public canEdit: boolean;
}
